<template>
    <div>
        <card-header title="Assigned Users" icon="fa-user-check"/>

        <card-body>
            <card-list>

                <portal-user-tile :user="u" :card="card" v-for="u in confUsers" />

                <card-list-item class="pb-5" no-hover>
                    <template #icon><i class="fa-fw fas fa-plus"></i></template>
                    <template #content>
                        <div class="columns">
                            <div class="column is-10">
                                <div class="mb-2">
                                    <b-select expanded placeholder="Assign User" v-model="userSelect">
                                        <option :value="u" v-for="u in users">{{ u.first_name }} {{ u.last_name }}</option>
                                    </b-select>
                                </div>

                            </div>
                            <div class="column has-text-right">
                                <p class="control">
                                    <button class="button is-primary" :disabled="!userSelect" @click="addUser"><i class="far fa-fw fa-plus"></i></button>
                                </p>
                            </div>
                        </div>
                    </template>
                </card-list-item>
            </card-list>

        </card-body>

    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../../http_client';
    import async from "async";
    import ApplicationTile from "../../../components/tiles/ApplicationTile.vue";
    import PortalUserTile from "../../../components/tiles/PortalUserTile.vue";

    export default {
        components: {PortalUserTile, ApplicationTile, SeparatorListItem, SubheaderListItem, CardListItem, CourseForm, NavigationListItem, CardList, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                confUsers: [],
                users: [],
                userSelect: null
            };
        },
        methods: {
            load: function(force) {
                this.$emit('loading', true);

                async.series([
                    (cb) => {
                        http.get('/conferences/' + this.props.confId + '/users', {force}).then(response => {
                            this.confUsers = response.data;
                            cb();
                        }).catch(err => {

                        });
                    },
                    (cb) => {
                        http.get('organizations/self', {force}).then(response => {
                            this.users = response.data.users;
                            cb();
                        }).catch(err => {

                        });
                    },

                ], err => {
                    this.$emit('loading', false);

                });


            },
            addUser: function() {
                this.$emit('loading', true);
                console.log(this.userSelect)
                http.post('/conferences/' + this.props.confId + '/users', {conference_id: this.props.confId, portal_user_id: this.userSelect.id}).then(response => {
                    this.reload();
                }).catch(err => {
                    this.$emit('loading', false);
                });
            },
            reload() {
                this.load(true);
            }
        },
        watch: {
        },
        mounted() {
            this.load();
        }
    };
</script>
